module.exports = __webpack_public_path__ + "static/img/laber.0bc21b94.png";